import axios from "../../../axiosClient";

export const getTimerProfile = async (
  pageSize: any,
  PageNumber: any,
  SortBy: any,
  SortDirection: any,
  id: any
) => {
  const body = {
    pageSize,
    PageNumber,
    SortBy,
    SortDirection,
  };
  const res = await axios.get(`/slpapp/TimerProfile/GetTimerProfile`, {
    params: { assetCode: id, ...body },
  });

  return res?.data;
};

export const getOperationMode = async () => {
  const res = await axios.get(`/slpapp/OperationMode/OperationMode`);

  return res?.data;
};
